(function () {
  'use strict';

  angular
      .module('tfc.Products')
      .controller('ProdDashboardCtrl', ProdDashboardCtrl);

  // @ngInject
  function ProdDashboardCtrl($q, $scope, $timeout, Upload, ProductMgr, Toast, styleSummary, recentFiles, dateUtil, $stateParams) {
    var vm = this;
    vm.styleSummary = styleSummary;
    vm.recentFiles = recentFiles.values;

    // Ui-grid Data Options
    vm.missingStyleDataFn = function (lastIdentifier) {
      return ProductMgr.findMissingStyles(lastIdentifier, $stateParams.brandKey);
    };

    vm.options = {
      columnDefs: [
        {name: 'brand', field: 'brand', cellTooltip: true, headerCellClass: 'ui-grid-header-custom', cellClass: 'ui-grid-cell-custom'},
        {name: 'style #', field: 'supplierStyle', cellTooltip: true, headerCellClass: 'ui-grid-header-custom', cellClass: 'ui-grid-cell-custom'},
        {name: 'date', field: 'shipDate', headerCellClass: 'ui-grid-header-custom', cellClass: 'ui-grid-cell-custom'},
        {name: 'status', field: 'status', headerCellClass: 'ui-grid-header-custom', cellClass: 'ui-grid-cell-custom'}
      ],
      infiniteScrollRowsFromEnd: 50,
      pageSize: 500
    };

    vm.getStyle =  function(gridData, index) {
      if(gridData && gridData.length){
        return {
          'brand-key': gridData[index].brandKey,
          'store-key': gridData[index].storeKey,
          'supplier-style': gridData[index].supplierStyle
        }
      }
    };

    vm.formatMissingStylesData = function(styles) {
      if(styles && styles.length)
      {
        return _.forEach(styles, function (data) {
          _.assign(data, {'shipDate': dateUtil.formatJsonDate(data.shipDate, 'dd/MM/yyyy')})
        });
      }
      else
      {
        return [];
      }
    };

    vm.getReport = function () {
      return ProductMgr.getReport($stateParams.brandKey).then(function (content) {
        download(content.dataBlob, content.fileName, "application/vnd-xls");
      });
    };
  }
})();
